module.exports = __webpack_public_path__ + "static/media/splash_IMG_3933-wide.d395cfce.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/search/img/splash_IMG_3933-wide.png
// module id = 945
// module chunks = 23